export default __webpack_public_path__ + "static/media/boy.5f638a6f.svg";